// Copyright 2018 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import * as tf from "@tensorflow/tfjs";

// Number of classes to classify
const NUM_CLASSES = 2;
// Webcam Image size. Must be 224.
const IMAGE_SIZE = 96;

export class TfMain {
  constructor(camera, machineId, ipAddress, setProbability, setDataCount) {
    console.log(machineId);
    // Initiate variables
    this.infoTexts = [];
    this.data = null;
    this.label = [];
    this.training = -1; // -1 when no class is being trained
    this.videoPlaying = false;
    this.trained = false;
    this.inputFirst = true;
    this.isTraining = false;
    this.ipAddress = ipAddress;
    this.numClasses = NUM_CLASSES;
    this.completeModel = null;
    this.exampleCount = new Array(NUM_CLASSES).fill(0);
    this.lastChildAddClass = null;
    this.machineId = machineId;
    this.result = -1;
    this.resultConfidence = 0;
    this.piboxPy = "";
    this.setProbability = setProbability;
    this.setDataCount = setDataCount;
    this.removing = false;

    this.body = document.body;
    if (camera.current !== undefined) {
      this.body = camera.current;
    }

    this.bindPage();

    // // Create video element that will contain the webcam image
    // this.video = document.createElement("video");
    // this.video.setAttribute("autoplay", "");
    // this.video.setAttribute("playsinline", "");

    // Create image element for picamera streaming
    this.video = document.createElement("img");

    // Add video element to DOM
    this.body.appendChild(this.video);

    // Create training buttons and info texts
    for (let i = 0; i < this.numClasses; i++) {
      const div = document.createElement("div");
      this.lastChildAddClass = div;
      this.body.appendChild(div);

      div.style.marginBottom = "10px";

      // Create training button
      const button = document.createElement("button");
      button.innerText = "데이터 추가 - 클래스 " + (i + 1);
      //div.appendChild(button);

      // Listen for mouse events when clicking the button
      button.addEventListener("mousedown", () => (this.training = i));
      button.addEventListener("mouseup", () => (this.training = -1));

      // Create info text
      const infoText = document.createElement("span");
      infoText.innerText = " 추가된 데이터가 없습니다.";
      //div.appendChild(infoText);
      this.infoTexts.push(infoText);
    }

    // let div = document.createElement("div");
    // this.lastChildAddClass = div;
    // this.body.appendChild(div);
    // div.style.marginBottom = "10px";

    // Create training button
    // let button = document.createElement("button");
    // button.innerText = "PLAi 학습하기";
    // button.id = "trainButton";
    // div.appendChild(button);

    // Listen for mouse events when clicking the button
    // button.addEventListener("mouseup", () => this.train());

    // div = document.createElement("div");
    // this.body.appendChild(div);
    // div.style.marginBottom = "10px";

    // Create training button
    // button = document.createElement("button");
    // button.innerText = "학습한 모델 저장";
    // button.id = "modelSave";
    // div.appendChild(button);

    // Listen for mouse events when clicking the button
    // button.addEventListener("mouseup", () => {
    //   this.download();
    // });

    //using webcam
    if (0) {
      // Setup webcam
      navigator.mediaDevices
        .getUserMedia({
          video: { width: IMAGE_SIZE, height: IMAGE_SIZE },
          audio: false,
        })
        .then((stream) => {
          this.video.srcObject = stream;
          this.video.width = IMAGE_SIZE;
          this.video.height = IMAGE_SIZE;

          this.video.addEventListener(
            "playing",
            () => (this.videoPlaying = true)
          );
          this.video.addEventListener(
            "paused",
            () => (this.videoPlaying = false)
          );
        });
    }
    //using picamera
    if (1) {
      this.video.src = "http://" + this.ipAddress + ":8000/stream.mjpg";
      this.video.width = 224;
      this.video.height = 224;
      this.video.crossOrigin = "anonymous";
    }
  }

  addTrainingData(label) {
    this.training = label;
  }

  async removeTrainingData(label) {
    if (
      label >= 0 &&
      label < this.numClasses &&
      this.exampleCount[label] > 0 &&
      this.data !== null &&
      !this.removing
    ) {
      this.removing = true;

      // canvas에서 뺀다.
      const canvasEl = document.getElementById("canvas-" + label.toString());
      try {
        canvasEl.removeChild(canvasEl.firstChild);
      } catch (error) {
        //no canvas
      }

      // find last child's index from the array
      var idx = this.label.lastIndexOf(label);
      this.label.splice(idx, 1);
      this.data = await this.data
        .slice([0], [idx])
        .concat(this.data.slice([idx + 1], [-1]), 0);

      // example count에서도 뺀다.
      this.exampleCount[label] -= 1;

      this.removing = false;
      // console.log(this.data.shape[0]);
    }
  }

  async loadMobileNet() {
    const mobilenet = await tf.loadLayersModel(
      `./assets/${IMAGE_SIZE}_0.35/model.json`
    );
    const layer = mobilenet.getLayer(
      IMAGE_SIZE === 160
        ? "global_average_pooling2d"
        : "global_average_pooling2d_1"
    );
    return tf.model({ inputs: mobilenet.inputs, outputs: layer.output });
  }

  async bindPage() {
    this.mobilenet = await this.loadMobileNet();
    this.mobilenet.trainable = false;
    this.mobilenet.predict(tf.zeros([1, IMAGE_SIZE, IMAGE_SIZE, 3]));

    //tf.setBackend("webgl");
    //console.log(this.model.summary());

    this.start();
  }

  start() {
    if (this.timer) {
      this.stop();
    }
    if (this.video.tagName === "video") this.video.play();
    else this.videoPlaying = true;
    this.timer = requestAnimationFrame(this.animate.bind(this));
  }

  stop() {
    if (this.video.tagName === "video") this.video.pause();
    this.videoPlaying = false;
    cancelAnimationFrame(this.timer);
  }

  train(callback) {
    if (!this.isTraining && this.label.length !== 0) {
      this.isTraining = true;
      const trainButton = document.getElementById("trainButton");
      //trainButton.innerText = "잠시 기다려주세요...";
      //trainButton.disabled = true;
      trainButton.src = "img/plai_training.svg";
      console.log("train start");

      let labels = null;
      this.model = tf.sequential();
      this.denseLayer1 = tf.layers.dense({
        inputShape: this.mobilenet.outputs[0].shape.slice(1),
        units: 100,
        activation: "relu",
        use_bias: true,
        kernel_initializer: "varianceScaling",
      });
      this.denseLayer2 = tf.layers.dense({
        units: this.numClasses,
        activation: "softmax",
        use_bias: false,
        kernel_initializer: "varianceScaling",
      });

      this.model.add(this.denseLayer1);
      this.model.add(this.denseLayer2);
      this.model.compile({
        optimizer: tf.train.adam(0.0001),
        loss: "categoricalCrossentropy",
        metrics: ["accuracy"],
      });

      this.label.forEach((e) => {
        const label = tf.oneHot(
          tf.tensor1d([parseInt(e)], "int32"),
          this.numClasses
        );
        if (labels === null) labels = label;
        else {
          const oldLabels = labels;
          labels = oldLabels.concat(label, 0);
          oldLabels.dispose();
        }
      });
      //this.data.print();
      //labels.print();
      function onBatchEnd(batch, logs) {
        console.log("Accuracy", logs.acc);
      }
      this.model
        .fit(this.data, labels, {
          epochs: 20,
          batchSize: parseInt(this.label.length * 0.4),
          callbacks: { onBatchEnd },
        })
        .then((info) => {
          console.log("Final accuracy", info.history.acc);
          this.trained = true;
          this.isTraining = false;
          trainButton.src = "img/plai_train.svg";
          //trainButton.innerText = "PLAi 학습하기";
          //trainButton.disabled = false;
          callback();
        });
    } else {
      alert(
        "데이터를 수집중이거나 학습할 데이터가 없는 클래스가 있어 학습을 시작할 수 없습니다."
      );
      callback();
    }
  }

  async download() {
    // const saveButton = document.getElementById("modelSave");
    // saveButton.innerText = "잠시 기다려주세요...";
    // saveButton.disabled = true;
    this.completeModel = tf.sequential();
    this.completeModel.add(this.mobilenet);
    try {
      this.completeModel.add(this.model);
    } catch (error) {
      return false;
    }

    try {
      //await this.completeModel.save("downloads://model");
      await this.completeModel.save(
        tf.io.http("http://tfjson-to-tflite.unicityclean.com/upload", {
          //tf.io.http("http://tfjson-to-tflite-2053599458.ap-northeast-2.elb.amazonaws.com/upload", {
          requestInit: {
            method: "POST",
            headers: { machine_id: this.machineId },
          },
        })
      );
      // saveButton.innerText = "(성공)학습한 모델 저장";
      // saveButton.disabled = false;
      return true;
    } catch (error) {
      // saveButton.innerText = "(실패)학습한 모델 저장";
      // saveButton.disabled = false;
      return false;
    }
  }

  async draw(image, label) {
    const [width, height] = [IMAGE_SIZE / 2, IMAGE_SIZE / 2];
    const canvasEl = document.getElementById("canvas-" + label.toString());
    const canvas = document.createElement("canvas");

    canvas.width = width;
    canvas.height = height;
    canvas.className = "cameraData";
    canvas.id =
      "data-" + label.toString() + "-" + this.data.shape[0].toString();
    canvasEl.insertBefore(canvas, canvasEl.firstChild);
    if (canvasEl.childNodes.length > 25)
      canvasEl.removeChild(canvasEl.lastChild);
    const ctx = canvas.getContext("2d");
    const imageData = new ImageData(width, height);
    const data = image.dataSync();
    for (let i = 0; i < height * width; ++i) {
      const j = i * 4;
      imageData.data[j + 0] = (data[i * 3 + 0] + 1) * 127;
      imageData.data[j + 1] = (data[i * 3 + 1] + 1) * 127;
      imageData.data[j + 2] = (data[i * 3 + 2] + 1) * 127;
      imageData.data[j + 3] = 255;
    }
    ctx.putImageData(imageData, 0, 0);
  }

  addClass() {
    this.exampleCount.push(0);
    this.setDataCount(this.exampleCount);
    this.numClasses += 1;
    const div = document.createElement("div");

    this.body.insertBefore(div, this.lastChildAddClass);

    div.style.marginBottom = "10px";

    // Create training button
    const button = document.createElement("button");
    button.innerText = "데이터 추가 - 클래스 " + this.numClasses;
    //div.appendChild(button);
    const nowClass = this.numClasses;
    // Listen for mouse events when clicking the button
    button.addEventListener("mousedown", () => (this.training = nowClass - 1));
    button.addEventListener("mouseup", () => (this.training = -1));

    // Create info text
    const infoText = document.createElement("span");
    infoText.innerText = " 추가된 데이터가 없습니다.";
    //div.appendChild(infoText);
    this.infoTexts.push(infoText);
  }

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async animate() {
    if (this.videoPlaying) {
      // Get image data from video element
      const image = tf.tidy(() =>
        tf.browser.fromPixels(this.video).resizeBilinear([96, 96])
      );

      let logits;
      // 'conv_preds' is the logits activation of MobileNet.

      // Train class if one of the buttons is held down
      if (this.training !== -1) {
        const newX = image.expandDims(0).toFloat().div(127).sub(1);
        // Add current image to classifier
        if (!this.inputFirst) {
          const oldData = this.data;
          this.data = oldData.concat(this.mobilenet.predict(newX), 0);
          this.label.push(this.training);
          oldData.dispose();
        } else {
          this.data = this.mobilenet.predict(newX);
          this.label.push(this.training);
          this.inputFirst = false;
        }
        await this.draw(newX.resizeBilinear([48, 48]), this.training);
        this.exampleCount[this.training] += 1;
        this.setDataCount(this.exampleCount);
        newX.dispose();
      }

      //if (hasClass(this.data.map(e => e.length)) > 0) {
      if (this.trained) {
        // If classes have been added run predict
        logits = tf.tidy(() =>
          this.model.predict(
            this.mobilenet.predict(
              image.expandDims(0).toFloat().div(127).sub(1)
            )
          )
        );
        const predictedClass = tf.tidy(() => logits.as1D().argMax());

        const res = (await predictedClass.data())[0];
        const confidence = await logits.data();
        this.setProbability(confidence);
        for (let i = 0; i < this.numClasses; i++) {
          // Make the predicted class bold
          if (res === i) {
            this.infoTexts[i].style.fontWeight = "bold";
            this.result = i;
            this.resultConfidence = confidence[i] * 100;
          } else {
            this.infoTexts[i].style.fontWeight = "normal";
          }
          if (this.exampleCount[i] > 0) {
            this.infoTexts[i].innerText = ` ${
              this.exampleCount[i]
            } examples - ${Math.round(confidence[i] * 100)}%`;
            this.setDataCount(this.exampleCount);
          }
        }
        predictedClass.dispose();
        logits.dispose();
      } else {
        for (let i = 0; i < this.numClasses; i++) {
          // The number of examples for each class

          // Update info text
          if (this.exampleCount[i] > 0) {
            this.infoTexts[i].innerText = ` ${this.exampleCount[i]} examples`;
            this.setDataCount(this.exampleCount);
          }
        }
      }

      // Dispose image when done
      image.dispose();
      // console.log(tf.memory());
    }
    await this.sleep(30);
    this.timer = requestAnimationFrame(this.animate.bind(this));
  }
}

//window.addEventListener("load", () => new Main());
